import React from 'react';

import { Badge, Group } from '@mantine/core';
import {
  defaultAnalysisInfo,
  sentimentInfo
} from 'pages/ManageSmartAssistant/Sections/ConversationSections/VoiceCallsSection/IndividualVoiceCallConversationView/SummaryTab/AnalysisItems';
import { SentimentAnalysis } from 'shared/interfaces/ConversationAnalysis';

export interface SentimentBadgeProps {
  sentiment: SentimentAnalysis;
}

export function SentimentBadge({ sentiment }: SentimentBadgeProps) {
  const { color, icon, label } = sentimentInfo[sentiment] || defaultAnalysisInfo;

  return (
    <Group spacing="xs">
      {icon}
      <Badge color={color} size="sm" tt="capitalize">
        {label}
      </Badge>
    </Group>
  );
}
